import { makeStyles } from '@material-ui/core/styles';

import { CARD_SHADOW_FILTER } from '../header.constants';

const useStyles = makeStyles((theme) => ({
  card: {
    boxSizing: 'border-box',
    minWidth: 222,
    height: 48,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(0, 6, 0, 4),
    border: `2px solid ${theme.colorPalette.white}`,
    borderRadius: theme.sizes.roundCorners,
    background: 'none',
    filter: CARD_SHADOW_FILTER,
    font: 'inherit',
    textAlign: 'left',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.colorPalette.beige_25
    },
    '&:disabled': {
      opacity: 0.5,
      cursor: 'default',
      backgroundColor: 'transparent'
    }
  },
  icon: {
    flexShrink: 0,
    width: 24,
    height: 24
  },
  text: {
    display: 'flex',
    flexDirection: 'column',
    whiteSpace: 'nowrap'
  },
  title: {
    fontSize: 14,
    lineHeight: '20px',
    color: theme.colorPalette.green_90
  },
  count: {
    fontSize: 10,
    lineHeight: '12px',
    color: theme.colorPalette.green_75
  }
}));

export default useStyles;
